import { render, staticRenderFns } from "./MoveMailboxModal.vue?vue&type=template&id=4e18d113"
import script from "./MoveMailboxModal.vue?vue&type=script&lang=js"
export * from "./MoveMailboxModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports